var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86593 12.3058L7.38303 6.78868L10.7662 10.1718C11.193 10.5986 11.88 10.5778 12.2756 10.1302L19.7393 1.72959C20.1036 1.32362 20.0828 0.699041 19.6976 0.303475C19.2812 -0.112911 18.5838 -0.102501 18.1882 0.345113L11.5365 7.81923L8.11171 4.39446C7.70573 3.98849 7.04993 3.98849 6.64395 4.39446L0.304482 10.7443C-0.101494 11.1503 -0.101494 11.8061 0.304482 12.2121L0.398168 12.3058C0.804144 12.7118 1.47036 12.7118 1.86593 12.3058Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.481065ede781a09cdb4f24613fe5bb83.svg";
export { ForwardRef as ReactComponent };